/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const SeeResults = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 18 15">
    <g id="UX-Specification-document" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Homepage_default_VD_Desktop-Copy" transform="translate(-972.000000, -1044.000000)" fill="#3D3D36" fillRule="nonzero">
        <g id="Group-6" transform="translate(960.000000, 1034.000000)">
          <g id="Results" transform="translate(12.000000, 10.000000)">
            <path
              d="M17.3,0.38 L5,0.38 C4.69624339,0.38 4.45,0.626243388 4.45,0.93 L4.45,2.76 L1,2.76 C0.696243388,2.76 0.45,3.00624339 0.45,3.31 L0.45,12.45 C0.465731355,13.1422753 0.755917645,13.7999252 1.25668035,14.2781818 C1.75744305,14.7564383 2.42773311,15.0160972 3.12,15 L15.32,15 C16.7188964,14.9944925 17.8500108,13.8589073 17.85,12.46 L17.85,0.93 C17.85,0.626243388 17.6037566,0.38 17.3,0.38 Z M1.59,12.45 L1.59,3.86 L7.59,3.86 L7.59,7.67 C7.58725736,7.81669267 7.64432247,7.95818651 7.74806798,8.06193202 C7.85181349,8.16567753 7.99330733,8.22274264 8.14,8.22 L12,8.22 L12,12.43 C12.0019451,12.9443053 12.1587561,13.4461006 12.45,13.8700592 L3.12,13.87 C2.31422941,13.877045 1.64298245,13.2540577 1.59,12.45 Z M11.21,7.12 L8.73,7.12 L8.73,4.64 L11.21,7.12 Z M16.75,12.43 C16.7500191,13.2214011 16.111382,13.8645042 15.32,13.87 L14.52,13.87 C13.728618,13.8645042 13.0899809,13.2214011 13.09,12.43 L13.09,7.67 C13.0905794,7.52390962 13.0330128,7.38359103 12.93,7.28 L8.57,2.92 C8.50085293,2.85359552 8.41407302,2.80846996 8.32,2.79 L8.24,2.79 L5.55,2.79 L5.55,1.48 L16.75,1.48 L16.75,12.43 Z"
              id="Shape"
            />
            <path
              d="M2.62,7.83 L6.62,7.83 C6.92375661,7.83 7.17,7.58375661 7.17,7.28 C7.17,6.97624339 6.92375661,6.73 6.62,6.73 L2.62,6.73 C2.31624339,6.73 2.07,6.97624339 2.07,7.28 C2.07,7.58375661 2.31624339,7.83 2.62,7.83 Z"
              id="Shape"
            />
            <path
              d="M10.56,9.21 L2.62,9.21 C2.31624339,9.21 2.07,9.45624339 2.07,9.76 C2.07,10.0637566 2.31624339,10.31 2.62,10.31 L10.56,10.31 C10.7058691,10.31 10.8457637,10.2520537 10.9489087,10.1489087 C11.0520537,10.0457637 11.11,9.90586907 11.11,9.76 C11.11,9.61413093 11.0520537,9.47423628 10.9489087,9.37109127 C10.8457637,9.26794626 10.7058691,9.21 10.56,9.21 Z"
              id="Shape"
            />
            <path
              d="M10.56,11.49 L2.62,11.49 C2.31624339,11.49 2.07,11.7362434 2.07,12.04 C2.07,12.3437566 2.31624339,12.59 2.62,12.59 L10.56,12.59 C10.7058691,12.59 10.8457637,12.5320537 10.9489087,12.4289087 C11.0520537,12.3257637 11.11,12.1858691 11.11,12.04 C11.11,11.8941309 11.0520537,11.7542363 10.9489087,11.6510913 C10.8457637,11.5479463 10.7058691,11.49 10.56,11.49 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default SeeResults
